/** Stats queries — cadence stats, step stats, performance, goals, metrics. */

export const CADENCE_STATS_QUERY = `
  query CadenceStats($cadenceId: ID!) {
    cadenceStats(cadenceId: $cadenceId) {
      cadenceId
      totalMembers
      activeMembers
      completedMembers
      qualifiedMembers
      removedMembers
      emailsSent
      emailsDelivered
      emailsOpened
      emailsClicked
      emailsBounced
      emailsReplied
      emailsUnsubscribed
      deliveryRate
      openRate
      clickRate
      replyRate
      bounceRate
      errorRate
      unsubscribeRate
    }
  }
`;

export const CADENCE_STATS_BATCH_QUERY = `
  query CadenceStatsBatch($cadenceIds: [ID!]!) {
    cadenceStatsBatch(cadenceIds: $cadenceIds) {
      cadenceId
      totalMembers
      activeMembers
      completedMembers
      qualifiedMembers
      removedMembers
      emailsSent
      emailsDelivered
      emailsOpened
      emailsClicked
      emailsBounced
      emailsReplied
      emailsUnsubscribed
      deliveryRate
      openRate
      clickRate
      replyRate
      bounceRate
      unsubscribeRate
      currentPercentage
      membersMeetingCriteria
    }
  }
`;

export const CADENCE_STEP_STATS_QUERY = `
  query CadenceStepStats($cadenceId: ID!, $timeRange: PerformanceTimeRange) {
    cadenceStepStats(cadenceId: $cadenceId, timeRange: $timeRange) {
      cadenceEventId
      eventType
      sequenceOrder
      stepLabel
      totalExecuted
      totalSkipped
      tasksCreated
      tasksCompleted
      tasksSkipped
      emailsSent
      emailsDelivered
      emailsOpened
      emailsClicked
      emailsBounced
      emailsReplied
      emailsUnsubscribed
      membersQualified
      membersExited
      skippedReasons
      errorCount
      errorReasons
    }
  }
`;

export const CADENCE_GOAL_PROGRESS_QUERY = `
  query CadenceGoalProgress($cadenceId: ID!) {
    cadenceGoalProgress(cadenceId: $cadenceId) {
      label
      currentPercent
      targetPercent
      progressPercent
    }
  }
`;

export const CADENCE_METRIC_PROGRESS_QUERY = `
  query CadenceMetricProgress($cadenceId: ID!) {
    cadenceMetricProgress(cadenceId: $cadenceId) {
      metrics {
        id
        metricType
        targetPercentage
        currentPercentage
        membersMeetingCriteria
        totalMembers
      }
    }
  }
`;

export const CADENCE_PERFORMANCE_QUERY = `
  query CadencePerformance($cadenceId: ID!, $timeRange: PerformanceTimeRange!, $grouping: TimeGrouping!, $cadenceEventId: ID) {
    cadencePerformance(cadenceId: $cadenceId, timeRange: $timeRange, grouping: $grouping, cadenceEventId: $cadenceEventId) {
      date
      emailsSent
      emailsDelivered
      emailsOpened
      emailsClicked
      emailsBounced
      emailsReplied
      emailsUnsubscribed
      membersEnrolled
      membersQualified
      membersRemoved
      successReached
      tasksCreated
      tasksCompleted
      tasksSkipped
    }
  }
`;

export const MEMBER_ITERATIONS_QUERY = `
  query MemberIterations($cadenceMemberId: ID!) {
    memberIterations(cadenceMemberId: $cadenceMemberId) {
      id
      iterationNumber
      enrolledAt
      enrolledByUserId
      enrollmentSource
    }
  }
`;
